import { parsePhoneNumberFromString, type CountryCode } from "libphonenumber-js";

const COUNTRY_ALIASES: Record<string, CountryCode> = {
  XZ: "XK",
};

/**
 * Affiche le téléphone avec l'indicatif du pays de l'adresse.
 * Un numéro déjà international n'est pas préfixé une seconde fois.
 */
export function formatPhoneWithIndicatif(
  phone: string | null | undefined,
  countryCode: string | null | undefined,
): string {
  const raw = phone?.trim() ?? "";
  if (!raw) return "";

  const iso = countryCode?.trim().toUpperCase() ?? "";
  const region = COUNTRY_ALIASES[iso] ?? (iso as CountryCode);
  const parsed = parsePhoneNumberFromString(raw, region || undefined);
  const digits = raw.replace(/\D/g, "");

  if (parsed && (parsed.isValid() || digits.length >= 8)) {
    return parsed.formatInternational();
  }

  return raw;
}
